// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";

var HashRouter = {};

var BrowserRouter = {};

var Routes = {};

var Route = {};

var Link = {};

var Internal = {
  Link: Link
};

function ReactRouterDom$Link(props) {
  var className = props.className;
  var href = props.href;
  var children = props.children;
  if (className !== undefined) {
    return JsxRuntime.jsx(ReactRouterDom.Link, {
                children: children,
                to: href,
                className: className
              });
  } else {
    return JsxRuntime.jsx(ReactRouterDom.Link, {
                children: children,
                to: href
              });
  }
}

var Link$1 = {
  make: ReactRouterDom$Link
};

export {
  HashRouter ,
  BrowserRouter ,
  Routes ,
  Route ,
  Internal ,
  Link$1 as Link,
}
/* react-router-dom Not a pure module */
